module.exports = __webpack_public_path__ + "static/ev_conversion_book-913cc6e7075f432038ac9973d7566fd2.jpg";